<!--
 * @Author: chenlin
 * @Date: 2019-08-22 17:17:11
 * @Description: 登记表
 -->
<template>
  <div v-loading.fullscreen="loading">
    <el-card>
      <condition-search ref="search" :query-items="queryItems" :search-param="searchParam" @search="search"
        @reset="reset">
      </condition-search>
    </el-card>
    <el-card>
      <el-table ref="dataTable" :data="pageListData" highlight-current-row border :height="heightStyleObj"
        style="width:100%;margin-top: 10px">
        <el-table-column show-overflow-tooltip label="发货日期">
          <template slot-scope="{row}">
            {{ row.specifyDeliveryDate ? parseTime(row.specifyDeliveryDate) : null }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="mailNo" label="快递单号" />
        <el-table-column show-overflow-tooltip prop="trackMailNo" label="签回单号" />
        <el-table-column show-overflow-tooltip prop="payMethod" label="付款方式">
          <template slot-scope="{row}">
            <dict-tag :options="dictObj.pay_method" :value="row.payMethod" />
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="receiverName" label="收货人" width="80px" / />
        <el-table-column show-overflow-tooltip prop="receiverMobile" label="联系电话" />
        <el-table-column show-overflow-tooltip prop="actualWeight" label="重量" width="80px" />
        <el-table-column show-overflow-tooltip width="140px" prop="bizId" label="单据编号" />
        <el-table-column show-overflow-tooltip prop="issuingOffice" label="开票单位" />
        <el-table-column show-overflow-tooltip prop="receiverAddress" label="收货单位/地址" min-width="120px" />
        <el-table-column show-overflow-tooltip prop="cost" label="运费" width="80px" />
        <el-table-column show-overflow-tooltip label="随货物品" width="80px">
          <template slot-scope="scope">
            {{ scope.row.withTheGoodsText }}{{ scope.row.withOtherContent }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="寄出日期" min-width="140px">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.sendOutDate" type="date" style="width: 160px;" :clearable="false"
              @change="changeDate(scope.row, 'jcsj')">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="是否签回" min-width="120px">
          <template v-if="Number(scope.row.signBack) == 1" slot-scope="scope">
            <el-radio v-model="scope.row.signBackResult" label="Y" @change="changeDate(scope.row, 'sfqh')">是</el-radio>
            <el-radio v-model="scope.row.signBackResult" label="N" @change="changeDate(scope.row, 'sfqh')">否</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="orderStatus" label="订单状态" width="80px">
          <template slot-scope="scope">
            <dict-tag :options="dictObj.orderStatus" :value="scope.row.orderStatus" />
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
        :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
    </el-card>
    <video id="video" style="height:0.1px" src="@/assets/wrongTone.wav" />
  </div>
</template>

<script>
// import XLSX from '@/assets/cdns/xlsx.js'
import { registrationExpressSignBack, getCreatedLastMonthList, getRegist } from '@/api/orderManage'
import { getDict } from '@/api/common'

export default {
  data() {
    return {
      dictObj: {
        pay_method: []
      },
      pageListData: [],
      loading: false,
      searchParam: {
        pageNum: 1,
        pageSize: 100,
        total: 0,
      },
      heightStyleObj: '',
    }
  },
  created() {
    this.heightStyleObj = window.innerHeight - 425 + 'px'
    this.getPageListData()
    this.initScanCode('registrationDate', 10)
    this.getDicts(['pay_method'])
  },
  methods: {
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
        })
      })
    },
    registrationDate(code, self) {
      // 根据快递回单登记是否签回
      self.registrationExpressSignBack(code)
    },
    // 导出
    export2Excel() {
      const header = ['发货日期', '部门', '快递单号', '签回单号', '付款方式', '收货人', '收货人联系方式', '重量', '单据编号', '开票单位', '收货单位/地址', '随货物品']
      const list = this.pageListData.map((item) => {
        const { specifyDeliveryDate, applyOrgName, mailNo, trackMailNo, payMethod, receiverName, receiverMobile, actualWeight, bizId, receiverAddress, issuingOffice, withTheGoodsText, withOtherContent } = item
        return {
          specifyDeliveryDate: this.parseTime(specifyDeliveryDate),
          applyOrgName,
          mailNo,
          trackMailNo,
          payMethod: this.dictObj.pay_method.find(dict => dict.dictValue === payMethod).dictLabel,
          receiverName,
          receiverMobile,
          actualWeight,
          bizId,
          receiverAddress,
          issuingOffice,
          withTheGoodsText: withOtherContent + withTheGoodsText
        }
      })
      this.hanleExport(list, header, '登记表')
    },
    // 导出次月揽件表
    exportNextMonth() {
      // 获取次月揽件表里订单创建时间为上月的数据
      this.loading = true
      getCreatedLastMonthList().then(res => {
        const list = res.data.map((item) => {
          const { bizId, mailNo, specifyDeliveryDate, orderCreateDate, lanjianDate, createdDate } = item
          return {
            bizId,
            mailNo,
            specifyDeliveryDate: this.parseTime(specifyDeliveryDate, '{y}-{m}-{d}'),
            orderCreateDate: this.parseTime(orderCreateDate, '{y}-{m}-{d}'),
            lanjianDate: this.parseTime(lanjianDate, '{y}-{m}-{d}'),
            createdDate: this.parseTime(createdDate, '{y}-{m}-{d}'),
          }
        })
        this.hanleExport(list, ['单据编号',
          '快递母单号',
          '指定发货日期',
          '订单创建时间',
          '揽件时间',
          '创建时间'], '次月揽件表')
      }).finally(() => {
        this.loading = false

      })
    },
    hanleExport(list, header, title) {
      /* generate worksheet and workbook */
      const workSheet = XLSX.utils.json_to_sheet(list)
      const workBook = XLSX.utils.book_new()
      /* fix headers */
      XLSX.utils.sheet_add_aoa(workSheet, [header], { origin: 'A1' })
      if (!workSheet['!cols']) workSheet['!cols'] = []
      for (let i = 0; i <= 21; i += 1) {
        if (i === 0 || i === 1) {
          workSheet['!cols'][i] = { wpx: 480 }
        }
      }
      XLSX.utils.book_append_sheet(workBook, workSheet, 'title')
      XLSX.writeFile(workBook, `${title}.xlsx`)
    },
    // 获取登记表数据
    getPageListData() {
      this.loading = true
      getRegist(this.searchParam)
        .then(res => {
          this.pageListData = res.data.records
          this.searchParam.total = res.data.total
        })
        // eslint-disable-next-line handle-callback-err
        .finally(() => {
          this.loading = false
        })
    },
    changeDate(data, val) {
      let self = this
      self.loading = true
      let params = {}
      params.orderCode = data.orderId
      params.czType = val
      if (val === 'jcsj') {
        params.sendOutDate = data.sendOutDate
      } else if (val === 'sfqh') {
        params.signBackResult = data.signBackResult
      }
      self.publicApi
        .changeDateV2(params)
        .then(res => {
          if (res.code === '200') {
            self.$message({
              type: 'success',
              message: res.msg
            })
          } else {
            self.$message({
              type: 'error',
              message: res.msg
            })
          }
          self.loading = false
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          self.$message({
            type: 'error',
            message: '修改寄出时间失败'
          })
          self.loading = false
        })
    },
    registrationExpressSignBack(code) {
      registrationExpressSignBack({ code }).catch(() => {
        this.wrongTone()
      }).finally(() => {
        this.loading = false
      })
    },
    // 重置查询
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getPageListData()
    },
    search(){
      this.searchParam.pageNum = 1
      this.getPageListData()
    },
    wrongTone() {
      document.getElementById('video').play()
    },
  }
}
</script>
